import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./Editor.css";
import AtomicUnitCounts from "editor/components/AtomicUnitCounts";
import Sidekick from "components/library/Sidekick";
import WordCount from "editor/components/WordCount";
import { Editor as DraftJs } from "draft-js";
import blockRendererFn from "editor/utils/blockRendererFn";
import blockStyleFn from "editor/utils/blockStyleFn";
import keyBindingFn from "editor/utils/keyBindingFn";
import extendedBlockRenderMap from "editor/utils/extendedBlockRenderMap";
import { TEMPLATES, BLOCK_TYPE, STYLE_MAP } from "config/constants/editor";

import "draft-js/dist/Draft.css";

export default class Editor extends React.Component {
  constructor(props) {
    super(props);
    this.editor = {};
  }

  render() {
    const contentState = this.props.editorState.getCurrentContent();
    const className = classNames(styles.root, {
      [styles.disabled]: this.props.isDisabled,
      [styles[this.props.template.type]]: !!this.props.template,
      "Editor-hidePlaceholder":
        !contentState.hasText() &&
        contentState.getFirstBlock().getType() !== BLOCK_TYPE.UNSTYLED,
    });

    const stickyCountClassName = classNames(styles.stickyCount, {
      [styles.spacing]: this.props.contentType === "story",
    });

    // <div className={className} onClick={this.editor.focus}> <--- is buggy but the right idea
    return (
      <div className={className} data-cy={this.props.dataCy}>
        <DraftJs
          editorState={this.props.editorState}
          onChange={this.props.onChange}
          placeholder={this.props.placeholder}
          blockStyleFn={blockStyleFn}
          blockRendererFn={blockRendererFn}
          blockRenderMap={extendedBlockRenderMap}
          handleKeyCommand={this.props.handleKeyCommand}
          handleReturn={this.props.handleReturn}
          handlePastedText={this.props.handlePastedText}
          keyBindingFn={keyBindingFn}
          onTab={this.props.onTab}
          ref={node => {
            this.editor = node;
          }}
          readOnly={this.props.readOnly}
          customStyleMap={STYLE_MAP}
          spellCheck={true}
          onBlur={this.props.onBlur}
        />
        <div className={styles.staticCount}>
          {this.props.contentType === "story" && (
            <AtomicUnitCounts
              editorState={this.props.editorState}
              hasPrimaryImage={Boolean(this.props.primaryImage)}
            />
          )}
        </div>
        <div className={stickyCountClassName}>
          <WordCount
            editorState={this.props.editorState}
            multiEditorBlockComposition={this.props.multiEditorBlockComposition}
          />
        </div>
        {this.props.error && (
          <Sidekick hasError={true} title={this.props.error.title}>
            {this.props.error.message}
          </Sidekick>
        )}
      </div>
    );
  }
}

Editor.defaultProps = {
  template: TEMPLATES.DEFAULT,
};

Editor.propTypes = {
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  handleKeyCommand: PropTypes.func.isRequired,
  handleReturn: PropTypes.func.isRequired,
  handlePastedText: PropTypes.func.isRequired,
  template: PropTypes.object,
  onTab: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  multiEditorBlockComposition: PropTypes.object, // Only passed in to props if this is a newsletter
  primaryImage: PropTypes.object,
  contentType: PropTypes.oneOf(["newsletter", "story"]),
  isDisabled: PropTypes.bool,
  dataCy: PropTypes.string,
};
